// extracted by mini-css-extract-plugin
export default {"title":"Lipogram_title__6+NCu"};